import React from "react";
import { SvgComponent } from "./../../definitions/Svg";

const Twitter: SvgComponent = (props) => (
  <svg width="1.25em" height="1em" viewBox="0 0 20 16" {...props}>
    <path
      d="M19.8 1.9c-.8.3-1.5.5-2.3.6.9-.5 1.5-1.2 1.8-2.2-.8.5-1.7.8-2.6 1C15.9.4 14.9 0 13.8 0c-1.1 0-2.1.4-2.9 1.2-.8.8-1.1 1.7-1.1 2.8 0 .3 0 .6.1.9-1.7 0-3.2-.4-4.7-1.2C3.8 3 2.5 2 1.5.7c-.3.7-.5 1.4-.5 2.1 0 .7.2 1.3.5 1.9.3.6.8 1.1 1.3 1.4-.7 0-1.3-.2-1.8-.5 0 1 .3 1.8.9 2.6.6.8 1.4 1.2 2.3 1.4-.4.1-.7.2-1.1.2-.2 0-.5 0-.8-.1.3.8.7 1.5 1.4 2s1.5.8 2.3.8c-1.5 1.1-3.1 1.7-5 1.7H0C2 15.4 4.1 16 6.4 16c1.4 0 2.8-.2 4-.7 1.3-.5 2.3-1.1 3.2-1.8.9-.8 1.7-1.6 2.3-2.6.6-1 1.1-2 1.4-3.1.3-1.1.5-2.2.5-3.2v-.5c.8-.7 1.5-1.4 2-2.2z"
      fill="currentColor"
    />
  </svg>
);

export default Twitter;
